// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Switch_switchContainer__93bBC {
    display: flex;
    align-items: center;
    width: 300px; /* Задаем фиксированную ширину контейнера */
    border-radius: 20px;
    overflow: hidden;
}

.Switch_switchLabel__jl8-I {
    cursor: pointer;
    padding: 0.5rem;
    flex: 1 1;
    text-align: center;
    background-color: #181c3d;
    color: white;
    transition: background-color 0.3s ease, color 0.3s ease;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    width: 150px; /* Задаем фиксированную ширину метки */
    box-sizing: border-box; /* Учитываем padding в общей ширине */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}
.Switch_disable_label__FM9WF{
    opacity: 0.3;
}

.Switch_active__FHRTC {
    background-color: #007bff;
    color: #fff;
}

.Switch_switchSlider__QCZ-X {
    width: calc(50% + 1px);
    height: 100%;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    transition: margin-left 0.3s ease;

}
@media only screen and (max-width: 1000px) {
    .Switch_switchContainer__93bBC{
        width: 250px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Switch_bill/Switch.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY,EAAE,2CAA2C;IACzD,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,uDAAuD;IACvD,gCAAgC;IAChC,gBAAgB;IAChB,YAAY,EAAE,sCAAsC;IACpD,sBAAsB,EAAE,qCAAqC;IAC7D,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,iCAAiC;;AAErC;AACA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".switchContainer {\n    display: flex;\n    align-items: center;\n    width: 300px; /* Задаем фиксированную ширину контейнера */\n    border-radius: 20px;\n    overflow: hidden;\n}\n\n.switchLabel {\n    cursor: pointer;\n    padding: 0.5rem;\n    flex: 1;\n    text-align: center;\n    background-color: #181c3d;\n    color: white;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    font-family: Poppins, sans-serif;\n    font-weight: 600;\n    width: 150px; /* Задаем фиксированную ширину метки */\n    box-sizing: border-box; /* Учитываем padding в общей ширине */\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n.disable_label{\n    opacity: 0.3;\n}\n\n.active {\n    background-color: #007bff;\n    color: #fff;\n}\n\n.switchSlider {\n    width: calc(50% + 1px);\n    height: 100%;\n    background-color: #fff;\n    border-radius: 20px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n    transition: margin-left 0.3s ease;\n\n}\n@media only screen and (max-width: 1000px) {\n    .switchContainer{\n        width: 250px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switchContainer": `Switch_switchContainer__93bBC`,
	"switchLabel": `Switch_switchLabel__jl8-I`,
	"disable_label": `Switch_disable_label__FM9WF`,
	"active": `Switch_active__FHRTC`,
	"switchSlider": `Switch_switchSlider__QCZ-X`
};
export default ___CSS_LOADER_EXPORT___;
